import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
// import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";
import './CRUDTouchs.css';
import { Server_URL}  from "../config.js";

function CRUDTouchs() {
  // const [data, setData] = useState([])
  const [touchs, setTouchs] = useState([]);
  const [deleted, setDeleted] = useState(true)
  const [keyin, setKeyin] = useState([]);
  // const { id } = useParams();
  // const navigate = useNavigate();

  // console.log('get into CRUDTouchs()');
  useEffect(() => {
    if (deleted) {
      setDeleted(false)
      axios
        .get(`${Server_URL}/show_touchs`)
        // .get('http://localhost:3022/show_touchs')
        // .get('http://localhost:5000/show_touchs')
        // .then((res) => { setTouchs(res.data); console.log(Touchs); })
        .then((res) => { setTouchs(res.data) })
        .catch((err) => console.log(err))
    }
  }, [deleted])

  function handleDelete(id) {
    axios
      .delete(`${Server_URL}/delete_touch/${id}`)
      // .delete(`http://localhost:3022/delete_touch/${id}`)
      // .delete(`http://localhost:5000/delete_touch/${id}`)
      .then((res) => { setDeleted(true) })
      .catch((err) => console.log(err))
  }

  return (
    // <div className='container-fluid bg-primary vh-100 vw-100'>
    <div className='container-fluid vh-100 vw-100'>
      <div> <h2 className='text-center'>Touch Panel List</h2> </div>
      <div> <h1 className='crudtouch'> </h1> </div>
      <div className='d-flex justify-content-start'>
        <Link to='/CreateTouch' className='btn btn-success mx-2'>Add Touch</Link>
        <input type="text20" value={keyin} placeholder="Size..." onChange={(e) => setKeyin(e.target.value)} />
        <Link to={`/CRUDTouchsBySize/${keyin}`} className='btn btn-success mx-2'>Select Touch Size</Link>
        {/* <button className='btn btn-success' onClick={() => navigate(`/ListingTouchsBySize/${keyin}`)}>Touch Size</button> */}
      </div>
      <br />
      <h3 className='text-center'>Touch Panel Size All</h3>
      {/* <table className='table table-bordered'> */}
      {/* <table className='table'> */}
      {/* <table className='justify-content-center'> */}
      <table>
        <thead className='m-1 px-1 fs-6 text-center bg-success-subtle justify-content-center'>
          <tr>
            <th>-SNo-</th> <th>-Size-</th> <th>-PartNo-</th> <th>-Ratio-</th>
            <th>-CoverOD-</th> <th>-LcmAA-</th> <th>-CoverVA-</th> <th>-CGThick-</th>
            <th>-SensorOD-</th> <th>-SensorAA-</th> <th>-SGThick-</th>
            <th>-ChnRxTx-</th> <th>-CtrlCard/IC-</th>
            {/* <th>ChannelRxTx，</th> */}
            {/* <th>CGParam，</th> <th>SensorPN，</th> <th>ConnectorType，</th> */}
            {/* <th>ConnectorType，</th> <th>FpcType，</th> */}
            {/* <th>FWConfig，</th> <th>FWDownload，</th> <th>FWUpgrade，</th> <th>FWVersion，</th> */}
            {/* <th>Resolution，</th> <th>Original，</th> <th>TestBoard，</th> <th>TestDate，</th> */}
            {/* <th>RegistDate，</th> <th>Note，</th> <th>DrawYes，</th> */}
            <th>-Actions-</th>
          </tr>
        </thead>

        <tbody className='m-1 px-1 fs-6 text-center bg-primary-subtle'> {
          touchs.map((touch, i) => {
            // console.log(" touch.SNo :", touch.SNo, " touch.PartNo :", touch.PartNo);
            return (
              <tr key={i++}>
                <td>{touch.SNo}</td> <td>{touch.Size}</td> <td>{touch.PartNo}</td> <td>{touch.Ratio}</td>
                <td>{touch.CoverOD}</td> <td>{touch.LcmAA}</td> <td>{touch.CoverVA}</td> <td>{touch.CoverThick}</td>
                <td>{touch.SensorOD}</td> <td>{touch.SensorAA}</td> <td>{touch.SensorThick}</td>
                <td>{touch.ChannelRxTx}</td> <td>{touch.ControlIC}</td>
                {/* <td>{touch.ChannelRxTx}</td> */}
                {/* <td>{touch.CGParam}</td> <td>{touch.SensorPN}</td> <td>{touch.CustomerPN}</td> */}
                {/* <td>{touch.ConnectorType}</td> <td>{touch.FpcType}</td> */}
                {/* <td>{touch.FWConfig}</td> <td>{touch.FWDownload}</td> <td>{touch.FWUpgrade}</td> <td>{touch.FWVersion}</td> */}
                {/* <td>{touch.Resolution}</td> <td>{touch.Original}</td> <td>{touch.TestBoard}</td> <td>{touch.TestDate}</td> */}
                {/* <td>{touch.RegistDate}</td> <td>{touch.Note}</td> <th>DrawYes，</th> */}
                <td>
                  <Link to={`/ShowTouchDetail/${touch.SNo}`} className='btn trbtn-success m-1 px-2 py-1'>Read</Link>
                  <Link to={`/EditTouch/${touch.SNo}`} className='btn trbtn-success m-1 px-2 py-1'>Edit</Link>
                  <button onClick={() => handleDelete(touch.SNo)} className='btn trbtn-danger m-1 px-2 py-1'>
                    Delete
                  </button>
                </td>
              </tr>
            )
          })
        } </tbody>
      </table>
    </div>
  )
}

export default CRUDTouchs